import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#374963] group-[.toaster]:text-white group-[.toaster]:border-[#374963] group-[.toaster]:shadow-lg",
          title: "group-[.toast]:text-white group-[.toast]:font-medium",
          description: "group-[.toast]:text-white/80",
          actionButton:
            "group-[.toast]:bg-white group-[.toast]:text-[#374963]",
          cancelButton:
            "group-[.toast]:bg-white/20 group-[.toast]:text-white",
          success: "group-[.toaster]:text-white",
          error: "group-[.toaster]:text-white",
          info: "group-[.toaster]:text-white",
          icon: "group-[.toast]:text-white",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
